const STORAGE_KEY = 'smartcart-lists';
const OLD_FLAT_KEY = 'smartcart-list'; // pre-named-lists storage — migrated once below

function freshDefault() {
  return [{ id: crypto.randomUUID(), name: 'My List', items: [] }];
}

// One-time migration: fold any items stuck under the old flat key into "My List".
function migrateOldFlatList() {
  try {
    const raw = localStorage.getItem(OLD_FLAT_KEY);
    if (!raw) return null;
    const oldItems = JSON.parse(raw);
    localStorage.removeItem(OLD_FLAT_KEY);
    if (!Array.isArray(oldItems) || !oldItems.length) return null;
    return oldItems.map(deal => ({
      id:         crypto.randomUUID(),
      name:       deal.name,
      store:      deal.store,
      salePrice:  deal.salePrice,
      originalPrice: deal.originalPrice,
      quantity:   1,
      unit:       '',
      is_checked: false,
      added_via:  'deal',
    }));
  } catch {
    return null;
  }
}

export function loadLists() {
  let lists = null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length) lists = parsed;
    }
  } catch { /* fall through to default */ }

  const migrated = migrateOldFlatList();
  if (migrated) {
    lists = lists || freshDefault();
    lists = [{ ...lists[0], items: [...lists[0].items, ...migrated] }, ...lists.slice(1)];
    saveLists(lists);
  }

  return lists || freshDefault();
}

export function saveLists(lists) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(lists)); } catch { /* ignore */ }
}

export function getAllItems() {
  return loadLists().flatMap(l => l.items);
}

// Used by "Add to list" buttons outside the Shopping List tab (Deals, Favourites, For You, Compare, Assistant)
export function addDealToDefaultList(deal) {
  const lists = loadLists();
  const item = {
    id:            crypto.randomUUID(),
    name:          deal.name,
    store:         deal.store,
    salePrice:     deal.salePrice,
    originalPrice: deal.originalPrice,
    quantity:      1,
    unit:          '',
    is_checked:    false,
    added_via:     'deal',
  };
  const next = [{ ...lists[0], items: [...lists[0].items, item] }, ...lists.slice(1)];
  saveLists(next);
  return next.flatMap(l => l.items);
}
